import { Dogma } from 'shared/dogma';
import { httpclient } from '@/api/client';

export const dogma = new Dogma(httpclient);

export const doLoginPublishedView = ({ savedViewId, passphrase }) => httpclient.post('/login-published', { savedViewId, passphrase })
  .then((response) => response)
  .catch((error) => error.response);

export const doResetAccount = (payload) => httpclient.post('/delete-account', payload)
  .then((response) => response)
  .catch((error) => error.response);

export const doValidateCSV = (blob, lang, ignoreDeactivated = false) => httpclient.post(`/csv-validate?lang=${lang}&ignoreDeactivated=${ignoreDeactivated}`, blob)
  .then((response) => response)
  .catch((error) => error.response);

export const doImportCSV = (blob, lang, ignoreDeactivated = false) => httpclient.post(`/csv-import?lang=${lang}&ignoreDeactivated=${ignoreDeactivated}`, blob)
  .then((response) => response)
  .catch((error) => error.response);

export const doUploadFile = (formData, onUploadProgress = () => {
}) => httpclient.post(
  '/file',
  formData,
  { headers: { 'Content-Type': 'multipart/form-data' }, onUploadProgress },
).then((response) => response);

export const doCsvExport = ({ filter, goalCycles = [], includeDraft = false }) => httpclient.get('/csv-export', {
  params: {
    filter: JSON.stringify(filter),
    goalCycles: JSON.stringify(goalCycles),
    includeDraft,
  },
});

export const doGetPublicAccountData = (slug) => httpclient.post(
  '/public-account-data',
  { slug },
).then((response) => response).catch((error) => error.response);

export const doFindAccount = ({ model, uid }) => httpclient.post('/find-account', { model, uid })
  .then((response) => response)
  .catch((error) => error.response);

export const doAddAccount = () => httpclient.post('/add-account')
  .then((response) => response)
  .catch((error) => error.response);

export const doLeaveAccount = () => httpclient.post('/leave-account')
  .then((response) => response)
  .catch((error) => error.response);

export const doConnectBot = (signedRequest, accountId) => httpclient.post(
  '/microsoft-bot-connect',
  { signedRequest, accountId },
).then((response) => response).catch((error) => error.response);

export const doSendContactSales = ({
  firstName,
  lastName,
  email,
  plan,
  licences,
  message,
  hsTicketCategory,
  subject,
}) => httpclient.post('/contact-sales', {
  firstName,
  lastName,
  email,
  plan,
  licences,
  message,
  hsTicketCategory,
  subject,
})
  .then((response) => response)
  .catch((error) => error.response);

export const doProvisioningStatus = (userProvisioning) => httpclient.get(`/provisioning/status/${userProvisioning.uid}`).then((response) => response).catch((error) => error.response);

export const doProvisioningSync = (userProvisioning) => httpclient.post(`/provisioning/sync/${userProvisioning.uid}`).then((response) => response).catch((error) => error.response);

export const doGetSlackConsentUrl = (data) => httpclient.post('/slack-bot/consent-url', data)
  .then((response) => response)
  .catch((error) => error.response);

export const doGetStripePortal = (data) => httpclient.post('/stripe', data)
  .then((response) => response)
  .catch((error) => error.response);
